import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../context/UserContext';

function RightBar() {
  const navigate = useNavigate();
  const { isEligible } = useContext(UserContext);

  return (
    <>
      <div className="p-6 bg-white rounded shadow-md h-48">
        {/* Action Buttons (in the same row) */}
        <div className="mt-0">
          <button
            className="flex justify-between items-center w-full text-gray-500 px-0 py-2 rounded"
            onClick={() => navigate('/consultations')}
          >
            {/* Left-aligned content (text and gray square) */}
            <div className="flex items-center">
              {/* Solid gray square */}
              <div className="w-4 h-4 bg-gray-400 mr-3"></div>
              {/* Button Text */}
              <span>Book free consultation</span>
            </div>
            {/* Right-aligned icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="h-5 w-5 text-gray-500"
              viewBox="0 0 24 24"
            >
              <path d="M9 18l6-6-6-6v12z" />
            </svg>
          </button>
        </div>

        <hr className="my-2" />

        <div className="mt-0">
          {/* Apply For Application Button */}
          <button
            // className={`flex justify-between items-center w-full px-0 py-2 rounded 
            //   ${isEligible ? 'text-gray-500' : 'text-gray-300 cursor-not-allowed'}`}
            className="flex justify-between items-center w-full text-gray-500 px-0 py-2 rounded"
            onClick={() => navigate('/application')}
            // disabled={!isEligible}
          >
            {/* Left-aligned content (text and gray square) */}
            <div className="flex items-center">
              {/* Solid gray square */}
              {/* <div className={`w-4 h-4 mr-3 ${isEligible ? 'bg-gray-400' : 'bg-gray-300'}`}></div> */}
              <div className="w-4 h-4 bg-gray-400 mr-3"></div>
              {/* Button Text */}
              <span>Apply for new application</span>
            </div>
            {/* Right-aligned icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className={`h-5 w-5 ${isEligible ? 'text-gray-500' : 'text-gray-300'}`}
              viewBox="0 0 24 24"
            >
              <path d="M9 18l6-6-6-6v12z" />
            </svg>
          </button>
        </div>

        <hr className="my-2" />
      </div>
    </>
  );
}

export default RightBar;
